import { EntityType } from 'const';
import * as Models from 'models';
import { getValue } from 'utils/getter';

export function isReusableLayoutDocument(entity: Models.CombinedDocument): entity is Models.ReusableLayout;
export function isReusableLayoutDocument(entity: Models.CombinedDocumentMap): entity is Models.ReusableLayoutMap;
export function isReusableLayoutDocument(entity): boolean {
  return getValue(entity, 'entityType') === EntityType.LAYOUT;
}
